import { Box, Card, CardContent, Typography } from '@mui/material';
import styles from './TaskCard.module.scss';
import classNames from 'classnames/bind';
import { ClockIcon } from '~/assets/icons';
import { useTranslation } from 'react-i18next';
import { ITaskBoard } from '~/utils/interface/task';
import { BaseImage } from '~/components/common';
import dayjs from 'dayjs';

interface Props {
  task: ITaskBoard;
  column: any;
}

function TaskCard({ task, column }: Props) {
  const { t } = useTranslation('admin/job');
  const cx = classNames.bind(styles);
  return (
    <Box>
      <Card className={cx('container-card')}>
        <CardContent>
          <Box className={cx('card-content')}>
            <Typography variant='h6' className={cx('card-content-tittle')}>
              {task.name}
            </Typography>
          </Box>
          <Box className={cx('card-description')}>
            <Typography>{task.description}</Typography>
          </Box>

          <Box className={cx('card-due-time')}>
            <Box className={cx('card-clock')}>
              <ClockIcon className={cx('card-icon-clock')} />
              {t('detail.dueDate')}
            </Box>
            <Typography className={cx('card-time')}>
              {task?.createdAt ? dayjs(task.createdAt).format('DD MMM, YYYY') : ''}
            </Typography>
          </Box>

          <Box className={cx('border')}></Box>

          <Box className={cx('avatar-container')}>
            <Box className={cx('name-container')}>
              <Box>
                <BaseImage src={task.assignees?.avatar?.url} className={cx('avatar')} />
              </Box>
              <Typography className='ml-[10px]'>{task.assignees?.name}</Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default TaskCard;
